<template>
<!-- Footer -->
<footer class="footer">			
    <footertop></footertop>
    <footerbottom></footerbottom>
</footer>
<!-- /Footer -->
</template>